<template>
  <ScrollableList>
    <template #items>
      <Item
        v-for="shortcut in shortcuts"
        :key="shortcut.id"
        :isActive="isShortcutActive(shortcut.id)"
        @click="
          $emit('shortcutSelected', {
            shortcutId: shortcut.id,
            shortcutRange: shortcut.range(),
          })
        "
      >
        <template #content>
          <div class="flex flex-col overflow-hidden">
            <span class="font-medium text-base truncate">
              {{ t(shortcut.label) }}
            </span>
          </div>
        </template>
      </Item>
    </template>
  </ScrollableList>
</template>

<script setup>
import { ScrollableList, Item } from "@/Components/List";
import { useI18n } from "vue-i18n";
import { useDateShortcuts } from "@/Components/Date/DateShortcutsList";

defineEmits(["shortcutSelected"]);

const props = defineProps({
  activeShortcut: {
    type: String,
  },
});

function isShortcutActive(shortcutId) {
  return props.activeShortcut === shortcutId;
}

const { t } = useI18n();
const { shortcuts } = useDateShortcuts();
</script>
